"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAnyspendOrderHistory } from "../../../../anyspend/react/index.js";
import { Button, Skeleton, useAccountWallet } from "../../../../global-account/react/index.js";
import ModalHeader from "../../../../global-account/react/components/ModalHeader/ModalHeader.js";
import { RefreshCcw } from "lucide-react";
import { OrderHistoryItem } from "./OrderHistoryItem.js";
export function OrderHistory(t0) {
  const $ = _c(12);
  const {
    mode,
    onBack,
    onSelectOrder
  } = t0;
  const {
    connectedEOAWallet,
    address: smartWalletAddress
  } = useAccountWallet();
  let t1;
  if ($[0] !== connectedEOAWallet || $[1] !== smartWalletAddress) {
    t1 = connectedEOAWallet?.getAccount()?.address || smartWalletAddress;
    $[0] = connectedEOAWallet;
    $[1] = smartWalletAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const address = t1;
  const {
    orderHistory,
    isLoadingOrderHistory,
    refetchOrderHistory
  } = useAnyspendOrderHistory(address);
  let t2;
  if ($[3] !== refetchOrderHistory) {
    t2 = () => {
      refetchOrderHistory();
    };
    $[3] = refetchOrderHistory;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoadingOrderHistory || $[6] !== mode || $[7] !== onBack || $[8] !== onSelectOrder || $[9] !== orderHistory || $[10] !== t2) {
    t3 = _jsxs(_Fragment, {
      children: [_jsx(ModalHeader, {
        title: "Order History",
        showCloseButton: false,
        handleBack: onBack,
        className: "w-full",
        children: _jsx(Button, {
          variant: "ghost",
          size: "icon",
          className: "hover:bg-as-surface-secondary",
          onClick: t2,
          children: _jsx(RefreshCcw, {
            className: "text-as-secondary hover:text-as-primary h-5 w-5 cursor-pointer transition-all hover:rotate-180"
          })
        })
      }), isLoadingOrderHistory ? _jsx("div", {
        className: "w-full space-y-3 px-5",
        children: [1, 2, 3].map(_temp)
      }) : !orderHistory?.length ? _jsx("div", {
        className: "bg-as-surface-secondary w-full rounded-2xl p-12 px-5 text-center",
        children: _jsx("p", {
          className: "text-as-secondary text-sm",
          children: "No order history found"
        })
      }) : _jsx("div", {
        className: "mb-12 w-full px-5 pt-5",
        children: [...orderHistory].sort(_temp2).map(order => _jsx(OrderHistoryItem, {
          order,
          onSelectOrder,
          mode
        }, order.id))
      })]
    });
    $[5] = isLoadingOrderHistory;
    $[6] = mode;
    $[7] = onBack;
    $[8] = onSelectOrder;
    $[9] = orderHistory;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp2(a, b) {
  return b.createdAt - a.createdAt;
}
function _temp(i) {
  return _jsx(Skeleton, {
    className: "h-[180px] w-full rounded-2xl"
  }, i);
}